angular.module('iw.frontyard.math')
    .service('MathHelper', function () {

        var DEFAULT_DECIMALS = 2;

        class MathHelper {

            static round(number, optional_decimals) {
                var decimals = optional_decimals !== undefined ? optional_decimals : DEFAULT_DECIMALS;
                var multiple = Math.pow(10, decimals);
                return Math.round(number * multiple) / multiple;
            }

            static sum(array) {
                var total = 0;
                var arrayLength = array.length;
                for (var i = 0; i < arrayLength; i++) {
                    total += array[i];
                }
                return total;
            }
        }

        return MathHelper;
    });
